<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8dQ37/tc-custom/9781035812653.jpg?1720523648706" alt="This image is the cover for the book The Cleopatra Caper"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Cleopatra Caper
      </h1>
      <p class="bookDescription body article font2">
        <p>“I want to present Cleopatra to the World,” Lady Stanhope sighed and reached for her purse. Two very young and inexperienced detectives, Flinders Petrie and Thomas Pettigrew, were unexpectedly presented with the case of a lifetime. Flinders and Pettigrew, recent graduates of Oxford and rivals of Sherlock Holmes and John Watson, suddenly find themselves confronted with the task of finding Cleopatra’s tomb. The tomb’s location, as they quickly discovered, was protected by the adherents of an ancient cult. Their quest leads them to Cairo and Alexandria. They meet a mysterious woman, who is possibly the descendant of Cleopatra. Their story weaves between the ‘City of the Dead’ in Cairo and the ‘Mound of Shards’ in Alexandria. They discover that becoming a detective is more difficult than they imagined as students. Set against the background of the River War in the Sudan and written by an expert in archeology and Middle East history, readers will find this story a worthy successor to the Conan Doyle legacy. “Find me Cleopatra, and I will pay for all this….”</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Amos
      </h2>
      
      <p class="authorDescription body article">John Amos holds a PhD from the University of California at Berkeley and a JD from the Monterey College of Law. He has taught at university level for over 25 years in the fields of Middle Eastern Politics, Political Sociology, and Political Behavior. His academic publications include two books, Arab-Israeli Military-Political Relations: Arab Perceptions and the Politics of Escalation, and The Palestinian Resistance; Organization of a Nationalist Movement as well as numerous articles in major academic journals. He has also edited Gulf Security into the Eighties: Perceptual and Strategic Dimensions. He has lived in the Middle East, most notably in Egypt, Lebanon, Libya, and Turkey. He currently practices law.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e99fb24